import { createErrorMessage } from '../toolkit';

export const responseTimeoutErrorMessage = createErrorMessage(
  'RESPONSE_TIMEOUT',
  {
    payload: {
      errorCode: 'native_message_exchange_response_timout',
      errorDescription: 'No response received after sending a message',
    }
  }
);
